<template>
    <div class="newsMain">
        <div class="newsMainDiv" v-if="newsList">
            <div class="newsListHeadDiv">
                <div class="newsListHeadLeft" v-if="newsList.length >= 1" @click="newsDetailView(newsList[0])">
                    <el-image lazy style="height: calc(100% - 40px);width: auto;display: block;" :src="globalConfig.OAFilePath + newsList[0].noticeImg" fit="cover"></el-image>
                    <p class="imgLabel">{{newsList[0].noticeName}}</p>
                </div>
                <div class="newsListHeadRight" v-if="newsList.length >= 3">
                    <div style="height: calc(50% - 5px);" @click="newsDetailView(newsList[1])">
                        <el-image lazy style="height: calc(100% - 40px);width: 100%;display: block;" :src="globalConfig.OAFilePath + newsList[1].noticeImg" fit="cover"></el-image>
                        <p class="imgLabel">{{newsList[1].noticeName}}</p>
                    </div>
                    <div style="height: calc(50% - 5px);margin-top: 10px;" @click="newsDetailView(newsList[2])">
                        <el-image lazy style="height: calc(100% - 40px);width: 100%;display: block;" :src="globalConfig.OAFilePath + newsList[2].noticeImg" fit="cover"></el-image>
                        <p class="imgLabel">{{newsList[2].noticeName}}</p>
                    </div>
                </div>
            </div>
            <div class="newsListDiv">
                <template v-for="(item, index) in newsList">
                    <div class="newsListInfo" :key="index" v-if="index > 2">
                        <el-image lazy style="height: 250px;width: 450px;display: block;" :src="globalConfig.OAFilePath + item.noticeImg" fit="cover"></el-image>
                        <div class="newsListDetails">
                            <p class="newsListInfoTitle">{{item.noticeName}}</p>
                            <p class="newsListInfoTime">发布时间：{{item.statusDate}}</p>
                            <p class="newsListInfoContent" v-html="item.noticeContent.replace(/<[^>]+>/g, '')"></p>
                            <p class="newsListDetailsButton" @click="newsDetailView(item)">查看详情</p>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <el-dialog :title="newsDetail.noticeName" :visible.sync="newsDialogVisible" width="90%" top="5vh" center>
            <div class="newsDetail">
                <div v-html="newsDetail.noticeContent"></div>
            </div>
            <span slot="footer" class="dialog-footer" v-if="1 == 2">
                <el-button @click="newsDialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                currentPage: 1,
                pageSize: 15,
                newsList: [],
                newsDialogVisible: false,
                newsDetail: {},
            };
        },
        updated() {},
        mounted() {
            var that = this;
            that.getSysNoticeInfoPageList();
        },
        methods: {
            getSysNoticeInfoPageList: function () {
                //登录请求
                var that = this;
                //请求地址
                var url =
                    that.globalConfig.mainApi +
                    'sys/notice/getSysNoticeInfoPageList';

                //POST参数
                var postData = {
                    data: {
                        schoolId: that.globalConfig.schoolId,
                        currentPage: that.currentPage,
                        pageSize: that.pageSize,
                    },
                };

                postData = that.qs.parse(postData);

                that.axios
                    .post(url, postData)
                    .then(function (response) {
                        if (response.data.code == 1) {
                            that.newsList = response.data.data;
                        } else {
                            that.$message({
                                message: response.data.msg,
                                type: 'warning',
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getSysNoticeInfo(id) {
                //登录请求
                var that = this;
                //请求地址
                var url = that.globalConfig.mainApi + 'sys/notice/getSysNoticeInfo';

                //POST参数
                var postData = {
                    data: {
                        schoolId: that.globalConfig.schoolId,
                        id: id,
                    },
                };

                postData = that.qs.parse(postData);

                that.axios
                    .post(url, postData)
                    .then(function (response) {
                        if (response.data.code == 1) {
                            that.newsDetail = response.data.data;
                            that.newsDialogVisible = true;
                        } else {
                            that.$message({
                                message: response.data.msg,
                                type: 'warning',
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            newsDetailView(item) {
                var that = this;
                that.getSysNoticeInfo(item.id);
            },
        },
    };
</script>

<style scoped>
    .elementTitle {
        font-size: 32px;
        font-weight: bold;
        line-height: 60px;
        width: 100%;
        text-align: center;
    }

    .elementLabel {
        font-size: 16px;
        line-height: 30px;
        width: 100%;
        text-align: center;
    }

    .newsMainDiv {
        width: 65%;
        margin: 20px auto;
    }

    .newsMainDiv >>> img {
        transition: 0.3s;
    }

    .newsMainDiv >>> img:hover {
        transform: scale(1.1);
    }

    .imgLabel {
        background: #236de9;
        color: #fff;
        line-height: 40px;
        height: 40px;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 10px;
        box-sizing: border-box;
    }

    .newsListHeadDiv {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: space-between;
    }

    .newsListHeadLeft {
        width: 60%;
        height: 100%;
    }

    .newsListHeadRight {
        width: calc(40% - 10px);
        height: 100%;
        margin-left: 10px;
        display: flex;
        flex-direction: column;
    }

    .newsListDiv {
        width: 100%;
    }

    .newsListInfo {
        display: flex;
        justify-content: space-between;
    }

    .newsListInfo {
        margin-top: 20px;
    }

    .newsListDetails {
        width: calc(100% - 430px);
        height: 250px;
        margin-left: 20px;
        padding: 10px;
        box-sizing: border-box;
        overflow: hidden;
    }

    .newsListDetailsButton {
        width: 90px;
        height: 25px;
        line-height: 25px;
        overflow: hidden;
        border: 1px solid #236de9;
        color: #236de9;
        padding: 0 5px;
        box-sizing: border-box;
        cursor: pointer;
        text-align: center;
    }

    .newsListInfoTitle {
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .newsListInfoTime {
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .newsListInfoContent {
        width: 100%;
        height: 120px;
        line-height: 30px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-inline-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal;
        margin: 10px auto;
    }

    .newsDetail {
        width: 100%;
        height: 70vh;
        overflow: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/Widget/WidgetNews.vue